export default "__VITE_ASSET__BuUhvu3J__"